import { Adapter as i } from "../../../../../adapter.js";
import { LoyaltyProgrammeWalletModel as t } from "./loyaltyProgrammeWallet.model.js";
class m extends i {
  adapt(o) {
    return new t({
      proximityNotification: o.proximity_notification,
      proximityNotificationLocations: o.proximity_notification_locations
    });
  }
  serialize(o) {
  }
}
export {
  m as LoyaltyProgrammeWalletAdapter
};
//# sourceMappingURL=loyaltyProgrammeWallet.adapter.js.map
